import { render, staticRenderFns } from "./ChatBot.vue?vue&type=template&id=78446165&scoped=true"
import script from "./ChatBot.vue?vue&type=script&lang=js"
export * from "./ChatBot.vue?vue&type=script&lang=js"
import style0 from "./ChatBot.vue?vue&type=style&index=0&id=78446165&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78446165",
  null
  
)

export default component.exports